/**
 * Конфигурация для Edge Function запросов модуля статистики.
 * URL Supabase Edge Functions для Instagram статистики.
 */

import { projectId } from '../../../utils/supabase/info';

export const SUPABASE_FUNCTIONS_URL = `https://${projectId}.supabase.co/functions/v1/make-server-bde4f709`;
